document.addEventListener('DOMContentLoaded', function() {
  // Swiper //
  // - There is an older swiper in this theme that is using the inverted breakpoints
  // - Here the breakpoints work like max-width, and the initial settings are a fallback
  let upsellSwiper = new Swiper(".upsellSwiper", {
    slidesPerView: 3,
    spaceBetween: 22,
    // allowTouchMove: false,
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 13,
      }
    },
    navigation: {
      nextEl: ".upsell-swiper-container .swiper-button-next",
      prevEl: ".upsell-swiper-container .swiper-button-prev",
    },
  });

  // Upsell Section State Management //
  let selectedUpsellsList = [];
  const upsellSizeSelectors = document.querySelectorAll('.upsell-size-selector');
  const upsellQuantityDisplay = document.querySelector('#upsellQuantity')
  let upsellQuantity = 1; // 1 is for the initially displayed product
  const priceWithUpsellsDisplay = document.querySelector('#priceWithUpsells')
  const currentProductPrice = parseInt(priceWithUpsellsDisplay.textContent)
  let priceWithUpsells = currentProductPrice; // initial price is only the product on the page
  let buttonsRemoveUpsell = document.querySelectorAll('.removeUpsellItem')
  priceWithUpsellsDisplay.textContent = (priceWithUpsells / 100).toFixed(2) // transform initial price xxx00 into xxx.00
  let checkMarks = document.querySelectorAll('.checkMark')

  document.addEventListener('product:addedtocart', ()=>{

    console.log('upsell js: custom event received')
    let shopifyCart = { items: [] };
    selectedUpsellsList.forEach( item => {
      // prepare item to add to Shopify cart
      const shopifyCartItem =	{
        quantity: 1,
        id: item.variantid
      }
      shopifyCart.items.push(shopifyCartItem);
    });
  
    if (shopifyCart.items.length) {
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: shopifyCart,
        dataType: 'json',
        success: function(msg){
          resetUpsellSection();
          console.log('upsell js: the upsell section has been reset');
        },
        error: function(XMLHttpRequest, textStatus, errorThrown) {
          alert('Error: ' + XMLHttpRequest.responseJSON.description);
          console.log('Shopify add to cart error');
        }
      });
    }
    // setTimeout(() => {
    //   console.log('TIMEOUT > not exactly useful for fixing the problem')
    // }, 500)


  })


  
  // - onChange for every "upsell-product-size-selector-dropdown"
  upsellSizeSelectors.forEach(selector => {
    selector.addEventListener('change', (e) => { onUpsellSelectorChange(e) })
  })

  function onUpsellSelectorChange(e) {
    if (e.target.value != 'default') {
      // console.log(`The option of dropdown ${e.target.dataset.productid} has been changed to ${e.target.value}`)
      let variantPrice = e.target.options[e.target.selectedIndex].getAttribute("data-price")
      let upsellItem = {
        productid: e.target.dataset.productid,
        variantid: e.target.value,
        variantprice: variantPrice
      }
      console.log(selectedUpsellsList)
      // Display the "remove upsell" button
      let thisButtonRemoveUpsell = e.target.parentElement.querySelector('.removeUpsellItem')
      if (!thisButtonRemoveUpsell) {
        console.error('Couldnt get the removeUpsellItem button')
      } else if (thisButtonRemoveUpsell.classList.contains('v-hidden')) {
        thisButtonRemoveUpsell.classList.remove('v-hidden')
      }
      // Display the "check" mark
      e.target.closest('.swiper-slide').querySelector('.checkMark').classList.remove('d-none')
      updateSelectedUpsellList(upsellItem)
      updateQuantity()
      updateTotal()
    }
  }

  function hideThisBtnRemoveUpsell(button) {
    if (!button) {
      console.error('Couldnt get the removeUpsellItem button')
    } else if (button.classList.contains('v-hidden')) {
      console.error('The removeUpsellItem already has a v-hidden class, but it shouldnt have none')
    } else {
      button.classList.add('v-hidden')
    }
  }

  buttonsRemoveUpsell.forEach(button => {
    button.addEventListener('click', (e) => {
      // remove Upsell Item from list
      selectedUpsellsList = selectedUpsellsList.filter(item => item.productid != e.target.dataset.productid)
      hideThisBtnRemoveUpsell(e.target)
      // remove check mark
      e.target.closest('.swiper-slide').querySelector('.checkMark').classList.add('d-none')
      let thisSizeSelector = e.target.parentElement.querySelector('.upsell-size-selector')
      thisSizeSelector.value = 'default' // resets the dropdown to initial select option
      updateQuantity()
      updateTotal()
    })
  })

  function updateSelectedUpsellList(upsellItem) {
    let existingItem = selectedUpsellsList.find(element => element.productid == upsellItem.productid);
    // check if our array already has an upsellItem with the same product id as the item we're passing
    if (existingItem) {
      //if yes, update  variantid
      existingItem.variantid = upsellItem.variantid
    } else {
      // if no, add the upsellItem to our upsell list
      selectedUpsellsList.push(upsellItem)
    }
  }

  function updateQuantity() {
    upsellQuantity = selectedUpsellsList.length + 1 // 1 is for the initially displayed product
    upsellQuantityDisplay.textContent = upsellQuantity
  }

  function updateTotal() {
    let priceCounter = 0;
    for (const item of selectedUpsellsList) {
      priceCounter += parseInt(item.variantprice)
    }
    priceWithUpsells = priceCounter + currentProductPrice
    priceWithUpsellsDisplay.textContent = (priceWithUpsells / 100).toFixed(2)
  }

  function resetUpsellSection() {
    selectedUpsellsList = [];
    // reset dropdown menu
    upsellSizeSelectors.forEach(selector => {
      selector.value = 'default'
    })
    // hide all "remove upsell" buttons
    buttonsRemoveUpsell.forEach(button => {
      button.classList.add('v-hidden')
    })
    // remove all check marks
    checkMarks.forEach(checkMark => {
      checkMark.classList.add('d-none')
    })
    updateQuantity()
    updateTotal()
  }

});